import React from "react";
import { Box, Button } from "@showitinc/showit-wc";

import ButtonBar from "../base/ButtonBar";
import Panel from "../base/Panel";
import PanelContent from "../base/PanelContent";

import DomainSettingsActions from "../../actions/DomainSettingsActions";
import RedirectsTable from "./RedirectsTable";
import AddRedirectForm from "./AddRedirectForm";
import DataAvailabilityView from "../utils/DataAvailabilityView";

import HelpTooltip from "../HelpTooltip.jsx";
import SiteSettingsActions from "../../actions/SiteSettingsActions";
import { VIEW_DOMAIN } from "../../stores/SiteSettingsStore";
import UIActions from "../../actions/UIActions.js";
import AppConstants from "../../constants/AppConstants.js";

class RedirectsPanel extends React.Component {
  constructor(props) {
    super(props);
  }

  _onDelete(redirect) {
    DomainSettingsActions.redirectDelete(redirect);
  }

  _onSubmitAddForm(info) {
    DomainSettingsActions.submitAddForm();
  }

  _onAddFormUpdate(update) {
    DomainSettingsActions.updateAddForm(update);
  }

  _backToUpdateDomainView = () => {
    UIActions.modalOpen(AppConstants.MODAL_SITE_SETTINGS, {
      onHide: SiteSettingsActions.closeDialog,
    });
    SiteSettingsActions.changeView(VIEW_DOMAIN);
  };

  _getRedirectView() {
    let { redirects } = this.props;
    let list = redirects.get("list");
    let available = redirects.get("available");
    let error = redirects.get("error");

    return (
      <DataAvailabilityView available={available} error={error}>
        <RedirectsTable redirects={list} onDelete={this._onDelete} />
      </DataAvailabilityView>
    );
  }

  render() {
    let { panelSettings, domainName } = this.props;
    let addForm = panelSettings.get("addForm");

    return (
      <Panel style={{ padding: 15, paddingTop: 0 }}>
        <div style={{ paddingBottom: 8, display: "flex", justifyContent: "flex-end" }}>
          <HelpTooltip tooltipKey="seo-redirect" />
        </div>

        <PanelContent style={{ flexDirection: "column" }}>
          <AddRedirectForm
            form={addForm}
            onSubmit={this._onSubmitAddForm}
            onUpdate={this._onAddFormUpdate}
            domainName={domainName}
          />
          {this._getRedirectView()}
        </PanelContent>

        <ButtonBar>
          <Box mr={3}>
            <Button
              variant="minimal"
              onClick={() => {
                this.props.onClose();
                this._backToUpdateDomainView();
              }}
            >
              Back
            </Button>
          </Box>
          <Button variant="feature" onClick={this.props.onClose}>
            Close
          </Button>
        </ButtonBar>
      </Panel>
    );
  }
}

export default RedirectsPanel;
